<template>
  <div>

    <Loader :visible="isLoading" :text="loadingText" />

    <ConfirmationModal :show="showBarCodeModal" @close="showBarCodeModal = false">
        <template #title>
            {{ $t('gm.receiving') }} {{ $t('gm.item').toLocaleLowerCase() }}
        </template>

        <template #content>
          {{ $t('gm.enter_the_quantity_to_be_shipped') }} {{ itemRef?.Item }} <br>
          <input v-model="tmpQty" onfocus="this.select()" class="w-full p-3 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" type="number">
          ({{ itemRef?.Qty }} {{ $t('core.in_order') }}.)
        </template>

        <template #footer>
            <SecondaryButton @click="showBarCodeModal = false">
                {{ $t('actions.cancel') }}
            </SecondaryButton>

            <PrimaryButton
                class="ms-3"
                @click="itemRef.CommitQty = tmpQty; barcodeSearch = '', showBarCodeModal = false"
            >
                {{ $t('core.save') }}
            </PrimaryButton>
        </template>
    </ConfirmationModal>

    <ConfirmationModal :show="showQtyDiffModal" @close="showQtyDiffModal = false">
      <template #title>
        {{ $t('gm.confirm_mismatched_quantities') }}
      </template>
      <template #content>
        {{ $t('gm.confirm_mismatched_quantities_description') }}
        <ul class="mt-2 text-xs text-gray-600">
          <li v-for="row in qtyDiffRows" :key="row.Item">
            {{ $t('core.order') }}: {{ row.InternalOrdNo || row.SaleOrdId }}, {{ $t('core.item') }}: {{ row.Item }}<br>
            {{ $t('core.order') }}: {{ row.Qty }}, {{ $t('core.shipped') }}: {{ row.DeliveredQty }}, {{ $t('core.to_be_shipped') }}: {{ row.CommitQty }}
          </li>
        </ul>
      </template>
      <template #footer>
        <SecondaryButton @click="showQtyDiffModal = false">
          {{ $t('actions.cancel') }}
        </SecondaryButton>
        <PrimaryButton class="ms-3" @click="showQtyDiffModal = false; showSaveModal = true;">
          {{ $t('actions.confirm_and_save') }}
        </PrimaryButton>
      </template>
    </ConfirmationModal>

    <ConfirmationModal :show="showSaveModal" @close="showSaveModal = false">
      <template #title>
        {{ $t('actions.confirm') }} {{ $t('core.shipping').toLocaleLowerCase()}}
      </template>
      <template #content>
        <div class="mb-2">
          <label class="block text-sm font-medium mb-1">{{ $t('core.destination') }}</label>
          <select v-model="destinazione" class="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
            <option value=""></option>
            <option v-for="branch in branches" :key="branch.Branch" :value="branch.Branch">
              {{ branch.Branch }} - {{ branch.CompanyName }} - {{ branch.Address }}
            </option>
          </select>
        </div>
        <div class="mb-2">
          <label class="block text-sm font-medium mb-1">{{ $t('core.shipping_type') }}</label>
          <select v-model="tipoSpedizione" class="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
            <option value=""></option>
            <option v-for="option in shipping_by_list" :key="option.Shipping" :value="option.Shipping">
              {{ option.Shipping }} - {{ option.Description }}
            </option>
          </select>
        </div>
        <div class="mb-2">
          <label class="block text-sm font-medium mb-1">{{ $t('core.gross_weight') }}</label>
          <input v-model="pesoLordo" type="number" min="0" step="any" class="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" :placeholder="$t('core.gross_weight')">
        </div>
        <div class="mb-2">
          <label class="block text-sm font-medium mb-1">{{ $t('core.net_weight') }}</label>
          <input v-model="pesoNetto" type="number" min="0" step="any" class="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" :placeholder="$t('core.net_weight')">
        </div>
        <div class="mb-2">
          <label class="block text-sm font-medium mb-1">{{ $t('core.number_of_packages') }}</label>
          <input v-model="numeroColli" type="number" min="0" step="1" class="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" :placeholder="$t('core.number_of_packages')">
        </div>
      </template>
      <template #footer>
        <SecondaryButton @click="showSaveModal = false">
          {{ $t('actions.cancel') }}
        </SecondaryButton>
        <PrimaryButton class="ms-3" @click="Save">
          {{ $t('actions.save') }}
        </PrimaryButton>
      </template>
    </ConfirmationModal>

    <ConfirmationModal :show="showConfirmBinModal" @close="showConfirmBinModal = false">
      <template #title>
        {{ $t('gm.confirm_bin') }}
      </template>
      <template #content>
        <div>
          {{ $t('gm.insert_bin_to_confirm') }}<br>
          <input 
            v-model="tmpBinConfirm" 
            class="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 mt-2" 
            ref="confirmBinInput"
            @keydown.enter="$refs.confirmBinInput.blur()"
            onfocus="this.select()"
          >
        </div>
        <div v-if="tmpBinConfirm === items[itemConfirmBinIndex]?.Bin" class="mt-4">
          {{ $t('core.qty_to_register') }} <br>
          <input 
            v-model="tmpQty" 
            class="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 mt-2" 
            type="number"
            onfocus="this.select()"
          >
        </div>
        <label v-if="tmpQty > 0 && tmpQty != (Number(items[itemConfirmBinIndex]?.Qty) - Number(items[itemConfirmBinIndex]?.DeliveredQty))" class="text-red-600 text-sm mt-2 block">
          {{ $t('gm.qty_differs_from_remaining') + ' (' + items[itemConfirmBinIndex]?.Qty + ')' }}
        </label>
      </template>
      <template #footer>
        <SecondaryButton @click="showConfirmBinModal = false">
          {{ $t('actions.cancel') }}
        </SecondaryButton>
        <PrimaryButton 
          class="ms-3" 
          :disabled="tmpBinConfirm !== items[itemConfirmBinIndex]?.Bin || Number(tmpQty) != (Number(items[itemConfirmBinIndex]?.Qty) - Number(items[itemConfirmBinIndex]?.DeliveredQty))"
          @click="assignItemConfirmBin"
        >
          {{ $t('core.set') }}
        </PrimaryButton>
      </template>
    </ConfirmationModal>

    <div class="p-6 pb-0">
      <BreadCrumbs :navigation="navigation" />
    </div>
    <div class="p-6 pb-0 cont">
      <h2 class="text-lg font-semibold mb-2">{{ $t('core.order_details') }} {{ $t('core.customer') }}:</h2>
      <ul class="mb-4 text-sm">
        <li v-for="order in GetOrderList()" :key="order" class="inline-block mr-2 bg-blue-100 rounded px-3 py-1 mb-1">{{ order }}</li>
      </ul>
      <!--<div class="mb-6">
        <div class="relative">
          <input 
            v-model="barcodeSearch" 
            type="text" 
            :placeholder="$t('core.barcode_search') + '...'" 
            class="w-full p-3 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            @keyup.enter="searchItemfromBarcode"
            autofocus
          >
          <div class="absolute right-3 top-3 text-gray-400">
            <i class="fa fa-search"></i>
          </div>
        </div>
      </div>-->
      <div class="flex items-center justify-between mb-4">
        <label class="block text-sm font-medium mb-2">{{ $t('core.items_list') }}</label>
      </div>
      <!-- Legenda -->
      <div class="mb-4">
        <div class="flex items-center space-x-4">
          <div class="flex items-center space-x-2">
            <span class="inline-block w-6 h-6 border border-gray-300 bg-white rounded"></span>
            <span class="text-sm">{{ $t('gm.normal') }}</span>
          </div>
          <div class="flex items-center space-x-2">
            <span class="inline-block w-6 h-6 border border-gray-300 rounded" style="background-color: #DCDCDC;"></span>
            <span class="text-sm">{{ $t('gm.descriptive') }}</span>
          </div>
          <div class="flex items-center space-x-2" v-if="handle_kitchens">
            <span class="inline-block w-6 h-6 border border-gray-300 rounded" style="background-color: lightblue;"></span>
            <span class="text-sm">{{ $t('gm.kitchen') }}</span>
          </div>
        </div>
      </div>

      <PageNormalTable
        :headers="headers" 
        :items="items" 
        :sort-by="sortby" 
        :item-value="item => `${item.SaleOrdId}-${item.Position}`"
        hide-default-footer
        multi-sort
        :row-props="getRowProps"
        :mobile-filter-exclusions="['Qty', 'DeliveredQty', 'CommitQty']"
      >
        <template #item.DeliveredQty="{ item }">
            <span>{{ item.DeliveredQty }}{{ item.CommitQty > 0 ? ' (+' + item.CommitQty + ')' : '' }}</span>
        </template>
        <template #item.CommitQty="{ item, index }">
            <div v-if="item.LineType != MagoEnums.Line_Type.Descriptive && (!required_bin || (item.Bin != null && item.Bin != ''))">
              <span v-if="!item.ICAM_Row || item.StatusCode == '9'">
                  <input
                    class="w-full p-3 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    v-model="item.CommitQty"
                    type="number"
                    :max="getMaxCommitQty(item)"
                    @input="onCommitQtyInput(item)"
                    onfocus="this.select()"
                    v-if="!confirm_bin || item.Bin == null || item.Bin == ''"
                  >
                  <button v-else class="bg-blue-300 hover:bg-blue-500 text-white px-4 py-2 rounded" @click="showBinConfirm(index)">Conferma</button>
              </span>
              <span v-else-if="(item.Bin != null && item.Bin != '') && (item.StatusCode == null || item.StatusCode == '8')">
                  <button class="bg-blue-300 hover:bg-blue-500 text-white px-4 py-2 rounded" @click="sendIcamRequest(item)">{{ $t('gm.send_request') }}</button>
              </span>
              <span v-else-if="(item.Bin != null && item.Bin != '') && item.StatusCode == '5'">
                  <button class="bg-blue-300 hover:bg-blue-500 text-white px-4 py-2 rounded" @click="confirmIcamTaken(item)">{{ $t('gm.confirm_picking') }}</button>
              </span>
            </div>
        </template>
        <template #item.StatusCode="{ item }">
            <span>
              {{ getStatusCodeLabel(item) }}
            </span>
        </template>
      </PageNormalTable>

      <div class="pb-24"></div>
      <div class="fixed left-0 right-0 bottom-0 flex justify-center items-center pointer-events-none">
        <div class="flex gap-2 pointer-events-auto bg-white w-full px-4 py-3 justify-center">
          <button
            class="text-white bg-blue-400 hover:bg-blue-500 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
            @click="onConfermaClick"
            :disabled="!hasAtLeastOneCommit"
          >
            {{ $t('actions.confirm') }}
          </button>
        </div>
      </div>

    </div>
    <ToastNotification
      :show="toast.show"
      :message="toast.message"
      :type="toast.type"
      @update:show="toast.show = $event"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { Link, router, useForm } from '@inertiajs/vue3';
import BreadCrumbs from '@/Components/BreadCrumbs.vue';
import Pagination from '@/Components/Pagination.vue';
import PageNormalTable from '@/Components/PageNormalTable.vue';
import axios from 'axios';
import ConfirmationModal from '@/Components/ConfirmationModal.vue';
import PrimaryButton from '@/Components/PrimaryButton.vue';
import SecondaryButton from '@/Components/SecondaryButton.vue';
import ToastNotification from '@/Components/ToastNotification.vue';
import Loader from '@/Components/Loader.vue';
</script>
<style scoped>
  ::v-deep(.descriptive-row) {
    background-color: #DCDCDC !important;
  }
  ::v-deep(.kitchen-row) {
    background-color: lightblue !important;
  }
  ::v-deep(.v-table__wrapper) {
      min-height:500px;
  }
</style>

<script>
export default {
  props: ['items', 'icam_support', 'handle_kitchens', 'confirm_bin', 'required_bin', 'default_branch', 'default_shipping_by', 'shipping_by_list', 'branches'],
  components: {
    Link,
    BreadCrumbs,
    Pagination,
    Loader,
    PageNormalTable,
    ToastNotification,
  },
  data() {
    return {
      search: this.filters?.search || "",
      navigation: [
        { name: 'Dashboard', href: route('dashboard') },
        { name: this.$t('modules.gestione-magazzino'), href: route('modules.home', 'gestione-magazzino') },
        { name: this.$t('modules.evasione-ordini'), href: route('modules.gm.evasione') }
      ],
      barcodeSearch: '',
      showBarCodeModal: false,
      //showSaveModal: false,
      itemRef: undefined,
      tmpQty: 1,
      supplierDoc: '',
      supplierDate: '',
      //deletions: [],
      headers: [],
      sortby: [],
      ipp: 10,
      page: 1,
      showQtyDiffModal: false,
      qtyDiffRows: [],
      showSaveModal: false,
      itemConfirmBinIndex: -1,
      showConfirmBinModal: false,
      tmpBinConfirm: '',
      destinazione: '',
      tipoSpedizione: '',
      pesoLordo: '',
      pesoNetto: '',
      numeroColli: '',

      toast: {
        show: false,
        message: '',
        type: 'success'
      },

      isLoading: false,
      loadingText: ''
    };
  },
  computed: {
    hasAtLeastOneCommit() {
      return this.items.some(row => Number(row.CommitQty || 0) > 0);
    }
  },
  methods: {
    getRowProps(item)
    {
      return {
          class: item.item.LineType == this.MagoEnums.Line_Type.Descriptive ? 'descriptive-row' : (this.handle_kitchens && item.item.LineType == this.MagoEnums.Line_Type.Goods && item.item.Department == 'CUISINE' ? 'kitchen-row' : ((item.item.Bin == null || item.item.Bin == '') && this.required_bin ? 'bg-gray-100' : item.item.CommitQty > 0 ? 'bg-green-300' : '')),
      };
    },
    GetOrderList()
    {
      return [...new Set(this.items.map(x=>x.InternalOrdNo))];
    },
    searchItemfromBarcode(){
      let _this = this;
      axios.post(route('modules.gm.cercabarcode'), { barcode: this.barcodeSearch }).
      then((response) => {
        if (response.data.length > 0)
        {
          var list = _this.items.filter(x=>x.Item == response.data[0].Item && x.CommitQty == 0 && x.LineType != this.MagoEnums.Line_Type.Descriptive);

          if (list.length > 0){
            _this.itemRef = list[0];
            _this.tmpQty = 1;
            _this.showBarCodeModal = true;
          }
          else{
            _this.showToast(_this.$t('gm.item_not_found_or_already_pickedup', { item: response.data[0].Item }), 'warning');
          }
        }
        else{
          _this.showToast(_this.$t('gm.item_not_found'), 'error');
        }
      });
    },
    async showBinConfirm(index)
    {
      this.itemConfirmBinIndex = index;
      this.tmpBinConfirm = '';
      this.tmpQty = 0;
      this.showConfirmBinModal = true;
      this.$nextTick(() => {
        this.$refs.confirmBinInput.focus();
      });
    },
    assignItemConfirmBin(){
      this.items[this.itemConfirmBinIndex].CommitQty = Number(this.tmpQty);
      this.showConfirmBinModal = false;
    },
    onConfermaClick() {
      // Controlla se ci sono righe con CommitQty > 0 e CommitQty + DeliveredQty != Qty
      const diffRows = this.items.filter(
        row =>
          Number(row.CommitQty || 0) > 0 &&
          Number(row.CommitQty || 0) + Number(row.DeliveredQty || 0) !== Number(row.Qty || 0)
      );
      if (diffRows.length > 0) {
        this.qtyDiffRows = diffRows;
        this.showQtyDiffModal = true;
      } else {
        this.showSaveModal = true;
      }
    },
    Save()
    {
      this.isLoading = true;
      this.loadingText = this.$t('core.saving_data') + '...';

      axios.post(route('modules.gm.salvaEvasione'), {
        rows: this.items,
        destinazione: this.destinazione,
        tipoSpedizione: this.tipoSpedizione,
        pesoLordo: this.pesoLordo,
        pesoNetto: this.pesoNetto,
        numeroColli: this.numeroColli
      }).
      then((response) => {
        this.isLoading = false;
        if (response.data.success)
        {
          this.showToast(this.$t('core.successful_operation'), "success");

          /*
          var win = window.open('', '_blank');
          win.document.write(response.data.printcontent);
          win.document.close();
          win.focus();
          win.print();
          win.close();*/

          setTimeout(() => {
            router.get(route('modules.gm.evasione'));
          }, 1200);
        }
        else if (response.data.data?.Diagnostic?.Errors?.Error?.Message){
          this.showToast(response.data.data.Diagnostic.Errors.Error.Message, 'error');
        }
        else{
          this.showToast("Errore", "error");
        }
      }).catch((error) => {
        this.isLoading = false;
        this.showToast(this.$t('core.error'), 'error');
      });;
    },
    showToast(message, type = 'success') {
      this.toast.message = message;
      this.toast.type = type;
      this.toast.show = true;
    },
    getMaxCommitQty(item) {
      // Se riga cucina, limita a Qty
      if (item.LineType == this.MagoEnums.Line_Type.Goods && item.Department == 'CUISINE') {
        return Number(item.Qty) || 0;
      }
      return undefined;
    },
    onCommitQtyInput(item) {
      if (item.LineType == this.MagoEnums.Line_Type.Goods && item.Department == 'CUISINE') {
        if (Number(item.CommitQty) > Number(item.Qty)) {
          item.CommitQty = item.Qty;
        }
      }
    },
    async updateIcamStatus(){
      let _this = this;
      await axios.post(route('modules.gm.evadiDettagli'), { ids: [...new Set(this.items.map(x=>x.SaleOrdId))], isUpdate: true}).then((response) => {
        if (response.data.success) {
          var temp = JSON.parse(JSON.stringify(_this.items));
          _this.items.splice(0, _this.items.length);
          _this.items.push(...response.data.items);

          temp.forEach(oldItem => {
            let newItem = _this.items.find(i => i.SaleOrdId === oldItem.SaleOrdId && i.Position === oldItem.Position);
            if (newItem) {
              if (newItem.StatusCode == '9' && oldItem.StatusCode != '9'){
                newItem.CommitQty = newItem.Qty;
              }
              else newItem.CommitQty = oldItem.CommitQty;
            }
          });
        }
      }).catch((error) => {
        this.showToast(this.$t('core.error'), 'error');
      });
      setTimeout(this.updateIcamStatus, 10000);
    },
    sendIcamRequest(row){
      let _this = this;
      axios.post(route('modules.gm.richiestaICAM'), { row: row, type: 'saleOrdDetail' }).then((response) => {
        if (response.data.success) {
          _this.showToast(_this.$t('gm.icam_request_sent_successfully'), 'success');
          _this.updateIcamStatus();
        }
      }).catch((error) => {
        this.showToast(this.$t('core.error'), 'error');
      });
    },
    confirmIcamTaken(row){
      let _this = this;
      axios.post(route('modules.gm.confermaICAM'), { row: row, type: 'saleOrdDetail' }).then((response) => {
        if (response.data.success) {
          _this.showToast(_this.$t('gm.icam_request_sent_successfully'), 'success');
          _this.updateIcamStatus();
        }
      }).catch((error) => {
        this.showToast(this.$t('core.error'), 'error');
      });
    },
    getStatusCodeLabel(item) {
      if (!this.icam_support || !item.ICAM_Row || item.LineType == this.MagoEnums.Line_Type.Descriptive)
        return '';
      if (item.Bin == null || item.Bin == '')
        return 'Nessuna ubicazione';
      if (item.StatusCode)
      {
        switch(item.StatusCode) {
          case '0':
            return 'Creato';
          case '1':
            return 'Inviato a CPT Move';
          case '2':
            return 'Annullamento forzato';
          case '3':
            return 'Errore - ' + item.Status;
          case '4':
            return 'In lavorazione';
          case '5':
            return 'Ubicazione consentita';
          case '6':
            return 'Operazioni confermate';
          case '8':
            return 'Errore definitivo - ' + item.Status;
          case '9':
            return 'Concluso';
          default:
            return item.StatusCode;
        }
      }
      else return 'Da inviare';
    },
  },
  mounted()
  {
    //Primo caricamento
    this.headers = this.$attrs.headers;
    this.sortby = this.$attrs.sortby;

    this.destinazione = this.default_branch || '';
    this.tipoSpedizione = this.default_shipping_by || '';

    if (this.icam_support){
      setTimeout(this.updateIcamStatus, 10000);
    }
  }
};
</script>